import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "agent-bind-content",
  style: { transform: 'translateZ(0)' }
}
const _hoisted_2 = { class: "agent-bind-header" }
const _hoisted_3 = { class: "header-buttons" }
const _hoisted_4 = { class: "agent-bind-container" }

import {
  ref,
  computed,
  watch,
  onMounted,
  nextTick,
  onBeforeUnmount,
  h,
  reactive,
} from "vue";
import { useRoute } from "vue-router";
import { message, Modal, Table } from "ant-design-vue";
import type { FormInstance, TableColumnType } from "ant-design-vue";
import {
  DeleteOutlined,
  PlayCircleOutlined,
  FileTextOutlined,
} from "@ant-design/icons-vue";
import { TelegramClient } from "@/websocket/Client";
import AddAgentModal from "./AddAgentModal.vue";

interface LogItem {
  agentId: number;
  receiver: string;
  sendTime: string;
  errorMsg: string;
  phone: string;
}


 

// 表格列定义

export default /*@__PURE__*/_defineComponent({
  __name: 'AgentBindManager',
  props: {
    visible: { type: Boolean }
  },
  emits: ["update:visible"],
  setup(__props: any, { emit: __emit }) {

const agentDetailManagerVisible = ref(false);
const client = TelegramClient.getInstance();
const account = localStorage.getItem("username") || "";

// 定义日志数据的接口
const columns: TableColumnType[] = [
  {
    title: "代理状态",
    dataIndex: "valid",
    key: "valid",
    width: 80,
    align: "center",
  },
  {
    title: "TG账号",
    dataIndex: "phoneNum",
    key: "phoneNum",
    width: 80,
    align: "center",
  },
  {
    title: "代理IP类型",
    dataIndex: "proxy_type",
    key: "proxy_type",
    width: 160,
    align: "center",
  },
  {
    title: "IP或者域名",
    dataIndex: "proxy_adress",
    key: "proxy_adress",
    width: 160,
    align: "center",
  },
 
 
];

// 数据相关
const visible = ref(true);
const loading = ref(false);
const agents = ref<any[]>([]);
const selectedRowKeys = ref<number[]>([]);
const modalVisible = ref(false);
const confirmLoading = ref(false);
const formRef = ref<FormInstance>();



// 表单相关
const agentForm = ref<{
  phone: string[];
  message: string;
  targets: string[];
  startTime: Date | null;
  endTime: Date | null;
  interval: number | null;
  type: number;
}>({
  phone: [],
  message: "",
  targets: [],
  startTime: null,
  endTime: null,
  interval: null,
  type: 1,
});

// 添加新的 ref 用于存储发送者列表
const phoneList = ref<string[]>([]);

// 获取发送者列表
const fetchPhoneList = async () => {
  try {
    loading.value = true;
    const response = await client.getAccountList(account);
    if (response && response.list) {
      //console.log("获取发送者列表", response);
      phoneList.value = response.list.map((item: any) => item.strAccount);
    }
  } catch (error) {
    message.error("获取发送者列表失败");
  }
  loading.value = false;
};


const refreshAgents = (data)=>{
 // agents.value = data;
  console.log("refreshAgents");
  fetchUsers();
}

// 模态框回调处理方法
const handleAddAgentSuccess = () => {
    console.log("handleAddAgentSuccess");
};

// 添加新的 ref 用于存储接收者列表
const targetsList = ref<any[]>([]);

const rules = {
  phone: [{ required: true, message: "请输入发送者", trigger: "blur" }],
  message: [{ required: true, message: "请输入发送内容", trigger: "blur" }],
  targets: [{ required: true, message: "请选择接收者", trigger: "change" }],
  interval: [{ required: true, message: "请输入间隔时间", trigger: "change" }],
  type: [{ required: true, message: "请选择任务类型", trigger: "change" }],
};

// 接收父组件传入的 visible prop
const props = __props;

const emit = __emit;

// 使用计算属性处理 visible 状态
const isOpen = computed({
  get: () => props.visible,
  set: (value) => emit("update:visible", value),
});

// 监听可见性变化
watch(
  () => props.visible,
  (newVisible) => {
    if (newVisible) {
      console.log("任务管理页面显示，获取任务列表");
      fetchUsers();
    }
  }
);

// 处理关闭
const handleClose = () => {
  emit("update:visible", false);
};

const onClickAutoBind = async() => {
  console.log("onClickAutoBind");
  const response = await client.proxyAllocate(account,"");
    if (response.code === 1) {
         console.log("proxyAllocate");
         fetchUsers();
    }
    else
    {
       message.error(response.msg);
    }

};

// 获取任务列表
const fetchUsers = async () => {
     loading.value = true;
    const response = await client.proxyUserCheck(account);
    if(response && response.data)
    {
      agents.value = response.data;
    }
    loading.value = false;
   console.log("fetchUsers");
};

// 删除任务
const handleDelete = async (agentId: number) => {
 
};

// 定义 rowSelection 为计算属性以确保响应性
const rowSelection = computed(() => ({
  selectedRowKeys: selectedRowKeys.value,
  onChange: (selectedKeys: number[]) => {
    selectedRowKeys.value = selectedKeys;
  },
  onSelect: (record: any, selected: boolean) => {
    console.log("选择单行:", record, selected);
  },
  onSelectAll: (selected: boolean, selectedRows: any[], changeRows: any[]) => {
    console.log("全选切换:", selected, selectedRows.length);
  },
}));

 


// 显示任务模态框方法
const showAgentDetailModal = () => {
  agentDetailManagerVisible.value = true;
};

// 修改执行任务的处理函数
const handleExecute = async (agentIds: number[]) => {
 
};

// 添加响应式变量
const logModalVisible = ref(false);
const logData = ref<any[]>([]);
const currentAgentId = ref<number>();

const handleBind = async (record: any) => {
    const response = await client.proxyAllocate(account,record.phoneNum);
    if (response.code === 1) {
      fetchUsers();
    }
    else
    {
       message.error(response.msg);
    }
};

 
const getBindText = (record: any) => {
    console.log("valid="+record.valid + " proxy_adress=" + record.proxy_adress);
    if(record.proxy_adress == undefined)
    {
          return "绑定";
    }
    else
    {
         return "更换";
    }
};

 

const getProxyType = (proxy_type: number) => {
  //代理类型: 1-SOCKS5, 2-HTTP, 3-MTProto
     if(proxy_type == 1)
     {
        return "SOCKS5";
     }
     else if(proxy_type == 2)
     {
        return "HTTP";
     }
     else if(proxy_type == 3)
     {
        return "MTProto";
     }
     return "";
};

const getValidStatus = (record: any) => {
    console.log("valid="+record.valid + " proxy_adress=" + record.proxy_adress);
    if(record.valid == 1)
    {
       return "有效";
    }
    else{
       if(record.proxy_adress == undefined)
       {
          return "未绑定";
       }
       else
       {
          return "失效";
       }
    }
};

const agentBindManagerRef = ref<HTMLElement | null>(null);
let resizeObserver: ResizeObserver | null = null;

// 防抖函数
const debounce = (fn: Function, delay: number) => {
  let timer: NodeJS.Timeout;
  return (...args: any[]) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn(...args), delay);
  };
};

// 处理 ResizeObserver 的回调
const handleResize = debounce((entries: ResizeObserverEntry[]) => {
  for (const entry of entries) {
    // 只在真正需要处理尺寸变化时执行相关逻辑
    if (entry.target === agentBindManagerRef.value) {
      // 这里可以添加必要的尺寸调整逻辑
      console.debug("AgentManager size changed");
    }
  }
}, 100); // 100ms 的防抖延迟

onMounted(async () => {
  await nextTick();

  // 创建 ResizeObserver 实例
  resizeObserver = new ResizeObserver((entries) => {
    window.requestAnimationFrame(() => {
      handleResize(entries);
    });
  });

  // 只观察主容器元素
  if (agentBindManagerRef.value) {
    resizeObserver.observe(agentBindManagerRef.value);
  }

  // 错误处理
  const ignoreResizeObserverError = (error: ErrorEvent) => {
    if (error.message.includes("ResizeObserver")) {
      error.stopPropagation();
      return true;
    }
  };

  window.addEventListener("error", ignoreResizeObserverError);

  // 清理函数
  onBeforeUnmount(() => {
    window.removeEventListener("error", ignoreResizeObserverError);

    // 停止观察并断开连接
    if (resizeObserver) {
      resizeObserver.disconnect();
      resizeObserver = null;
    }
  });

  console.log("AgentManager组件已挂载");
  fetchUsers();
  //fetchPhoneList();
 
  //   agents.value = [
  //   {index:"1",valid:"有效",account:"helpmsg1",proxy_type:"socket5",address:"192.168.1.2"},
  //   {index:"2",valid:"无效",account:"helpmsg2",proxy_type:"socket5",address:"192.168.1.3"},
  //   {index:"3",valid:"有效",account:"helpmsg3",proxy_type:"socket5",address:"192.168.1.4"},
  //  ];


});

// 添加新的 ref
const addAgentModalVisible = ref(false);
const addAgentFormRef = ref<FormInstance>();

// 显示新增任务弹窗
const showAddAgentModal = async () => {
  console.log("showAddAgentModal");
  addAgentModalVisible.value = true;
  
};

 

// 处理新增任务
const handleAddAgent = async () => {
 
};

// 处理取消添加任务
const handleAddAgentCancel = () => {
  addAgentModalVisible.value = false;
  agentForm.value = {
    phone: [],
    message: "",
    targets: [],
    startTime: null,
    endTime: null,
    interval: null,
    type: 1,
  };
};

// 转换发送者列表为 Select 组件需要的格式
const phoneOptions = computed(() => {
  return phoneList.value.map((phone) => ({
    value: phone,
    label: phone,
  }));
});

// 添加发送者选择处理函数
const handlePhoneChange = (value: string[]) => {
  console.log("选择的发送者:", value);
  agentForm.value.phone = value;
};

const searchText = ref("");

// 过滤接收者列表
const filteredTargets = computed(() => {
  if (!searchText.value) return targetsList.value;
  const search = searchText.value.toLowerCase();
  return targetsList.value.filter(
    (target) =>
      target.name.toLowerCase().includes(search) ||
      (target.nickname && target.nickname.toLowerCase().includes(search))
  );
});

const onSearch = (value: string) => {
  searchText.value = value;
};

const handleBatchSelect = () => {
  // 获取当前过滤后的列表
  const currentList = filteredTargets.value;
  var count = currentList.length;
  // 使用 name 而不是 id
  const newTargets = currentList
    .slice(0, count)
    .map((target) => target.name);

  // 更新选择
  agentForm.value.targets = newTargets;
};

const handleClearSelection = () => {
  // 清空选择
  agentForm.value.targets = [];
};

const getStatusColor = (status: number) => {
 
  if(status == 1)
  {
     return 'blue';    // 待执行
  }
  else
  {
    return 'red';   // 异常
  }

};

const getStatusText = (status: number) => {
  switch (status) {
    case 1:
      return 'SOCKS5';
    case 2:
      return 'HTTP';
    case 3:
      return 'MTProto';
    default:
      return 'SOCKS5';
  }
};
 
// 添加链接编辑对话框的状态
const linkModalVisible = ref(false);
const linkForm = reactive({
  text: '',
  url: ''
});

// 添加文本格式化方法
const formatText = {
  bold: () => {
    const textarea = document.querySelector('.agent-bind-form-container textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    const selected = text.substring(start, end);
    
    if (!selected) {
      message.warning('请先选择要格式化的文本');
      return;
    }
    insertText(`*${selected}*`, start, end);
  },

  italic: () => {
    const textarea = document.querySelector('.agent-bind-form-container textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    const selected = text.substring(start, end);
    
    if (!selected) {
      message.warning('请先选择要格式化的文本');
      return;
    }
    insertText(`_${selected}_`, start, end);
  },

  underline: () => {
    const textarea = document.querySelector('.agent-bind-form-container textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    const selected = text.substring(start, end);
    
    if (!selected) {
      message.warning('请先选择要格式化的文本');
      return;
    }
    insertText(`__${selected}__`, start, end);
  },

  strikethrough: () => {
    const textarea = document.querySelector('.agent-bind-form-container textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    const selected = text.substring(start, end);
    
    if (!selected) {
      message.warning('请先选择要格式化的文本');
      return;
    }
    insertText(`~${selected}~`, start, end);
  },

  code: () => {
    const textarea = document.querySelector('.agent-bind-form-container textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    const selected = text.substring(start, end);
    
    if (!selected) {
      message.warning('请先选择要格式化的文本');
      return;
    }
    insertText(`\`${selected}\``, start, end);
  },

  codeblock: () => {
    const textarea = document.querySelector('.agent-bind-form-container textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    const selected = text.substring(start, end);
    
    if (!selected) {
      message.warning('请先选择要格式化的文本');
      return;
    }
    insertText(`\`\`\`\n${selected}\n\`\`\``, start, end);
  },

  spoiler: () => {
    const textarea = document.querySelector('.agent-bind-form-container textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    const selected = text.substring(start, end);
    
    if (!selected) {
      message.warning('请先选择要格式化的文本');
      return;
    }
    insertText(`||${selected}||`, start, end);
  },

  quote: () => {
    const textarea = document.querySelector('.agent-bind-form-container textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const text = textarea.value;
    const selected = text.substring(start, end);
    
    if (!selected) {
      message.warning('请先选择要格式化的文本');
      return;
    }
    const formatted = selected.split('\n').map(line => `> ${line}`).join('\n');
    insertText(formatted, start, end);
  },

  link: () => {
    const textarea = document.querySelector('.agent-bind-form-container textarea') as HTMLTextAreaElement;
    if (!textarea) return;
    
    const text = textarea.value;
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    linkForm.text = text.substring(start, end);
    linkForm.url = '';
    
    const currentPos = { start, end };
    (textarea as any).savedPos = currentPos;
    
    linkModalVisible.value = true;
  }
};

// 辅助函数：插入文本
const insertText = (newText: string, start: number, end: number) => {
  const textarea = document.querySelector('.agent-bind-form-container textarea') as HTMLTextAreaElement;
  if (!textarea) return;
  
  const text = textarea.value;
  agentForm.value.message = text.substring(0, start) + newText + text.substring(end);
  
  textarea.focus();
  const newPosition = start + newText.length;
  textarea.setSelectionRange(newPosition, newPosition);
};

// 处理链接确认
const handleLinkConfirm = () => {
  const textarea = document.querySelector('.agent-bind-form-container textarea') as HTMLTextAreaElement;
  if (!textarea) return;
  
  const { start, end } = (textarea as any).savedPos || { start: 0, end: 0 };
  const linkMarkdown = `[${linkForm.text}](${linkForm.url})`;
  
  insertText(linkMarkdown, start, end);
  linkModalVisible.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "agent-bind-manager",
      ref_key: "agentBindManagerRef",
      ref: agentBindManagerRef
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[3] || (_cache[3] = _createElementVNode("h2", null, "绑定IP管理", -1)),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: onClickAutoBind
            }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createTextVNode("自动分配")
              ])),
              _: 1
            }),
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: handleClose
            }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createTextVNode("返回")
              ])),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_a_table, {
            loading: loading.value,
            columns: columns,
            "data-source": agents.value,
            pagination: {
            pageSize: 10,
            showSizeChanger: true,
            showQuickJumper: true,
            showTotal: (total) => `共 ${total} 条`,
            size: 'default',
          },
            scroll: { x: '100%' },
            "row-key": "index",
            bordered: "",
            class: "custom-table"
          }, {
            bodyCell: _withCtx(({ column, record }) => [
              (column.key === 'proxy_adress')
                ? (_openBlock(), _createBlock(_component_a_space, {
                    key: 0,
                    size: 40
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(record.proxy_adress) + " ", 1),
                      _withDirectives(_createVNode(_component_a_button, {
                        type: "primary",
                        size: "small",
                        onClick: ($event: any) => (handleBind(record))
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_unref(FileTextOutlined))
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(" " + _toDisplayString(getBindText(record)), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]), [
                        [_vShow, true]
                      ])
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true),
              (column.key === 'valid')
                ? (_openBlock(), _createBlock(_component_a_tag, {
                    key: 1,
                    color: getStatusColor(record.valid)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(getValidStatus(record)), 1)
                    ]),
                    _: 2
                  }, 1032, ["color"]))
                : _createCommentVNode("", true),
              (column.key === 'proxy_type')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createTextVNode(_toDisplayString(getProxyType(record.proxy_type)), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["loading", "data-source", "pagination"])
        ])
      ])
    ], 512),
    _createVNode(AddAgentModal, {
      visible: addAgentModalVisible.value,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((addAgentModalVisible).value = $event)),
      onRefreshAgents: refreshAgents,
      onSuccess: handleAddAgentSuccess
    }, null, 8, ["visible"])
  ], 64))
}
}

})